import React from "react";

import Footer from "Components/Materials/Footer";
import Header from "Components/Materials/Header";

type IProps = {
	title: string;
	children: React.ReactChild | React.ReactChild[];
};
type IState = {};

export default class DefaultTemplate extends React.Component<IProps, IState> {
	public render(): JSX.Element {
		return (
			<>
				<Header />
				<>{this.props.children}</>
				<Footer />
			</>
		);
	}

	componentDidMount() {
		window.document.title = this.props.title;
	}
}

